module.exports = __webpack_public_path__ + "img/default_waypoint_image.67ce138d.png";